import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

function Canonical() {
  const location = useLocation();

  const baseUrl = "https://lakshmimaternity.com";
  const canonicalUrl = baseUrl + location.pathname.replace(/\/+$/, "");

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}

export default Canonical;